enum LoadingState {
    NotPopulated = 'NOT_POPULATED',
    RequestingData = 'REQUESTING_DATA',
    Loaded = 'LOADED',
    Errored = 'ERRORED',
    Aborted = 'ABORTED',
}

export default LoadingState
